import type { Platform } from "@/shared/types";
import { cn } from "cn";

const LOGO_SRC: Record<Platform, string> = {
    TikTok: "/icon-tiktok.svg",
    Instagram: "/icon-instagram.svg",
    YouTube: "/icon-youtube.svg",
};

export type LogoIconProps = {
    brand: Platform;
    className?: string;
    /** Custom when set, otherwise uses brand name */
    title?: string;
};

export function LogoIcon({ brand, className, title }: LogoIconProps) {
    return (
        <img
            src={LOGO_SRC[brand]}
            alt={title ?? brand}
            aria-hidden={title ? undefined : true}
            className={cn("inline-block size-5 shrink-0 rounded", className)}
        />
    );
}
